import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/SingleProfile.css";
import { badge, comment, service1, singleProfile } from "../../Constant";
import { connect } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faComment,
    faStar,
    faSuitcase,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import GoogleMapsReact from "google-map-react";
import { Calendar, momentLocalizer } from "react-big-calendar";

const SingleProfile = ({ auth }) => {
    const localization = momentLocalizer(moment);
    const navigate = useNavigate();

    const { id, service_id } = useParams();
    const [careGiver, setCareGiver] = useState(null);
    const [loading, setLoading] = useState(true);

    const getUser = async () => {
        const res = await config.getApi(
            config.services.singleCareGiver(id),
            config.bearerHeaders(auth.token)
        );
        if (res) {
            setCareGiver(res.response.data);
            console.log(res.response.data);
            setLoading(false);
        }
    };

    useEffect(() => {
        getUser();

    }, []);

    if (loading) {
        return <div />;
    }

    return (
        <>
            <Header />
            {/* <!-- Single Profile Sec Start Here --> */}
            <section className="single_profile">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="profile_details">
                                <div className="profile_img mr-4">
                                    <figure>
                                        <img
                                            src={config.returnImage(careGiver)}
                                            alt=""
                                        />
                                    </figure>
                                </div>
                                <div className="detailsDv">
                                    <div className="favourite_btn">
                                        <label className="favourite_container">
                                            <span className="checkmark">
                                                <i className="fa fa-heart" aria-hidden="true" ></i>
                                            </span>
                                        </label>
                                    </div>
                                    <div className="top_detail_wrapper">
                                        <h3 className="name">
                                            {careGiver.full_name}
                                        </h3>
                                        <div className="badge">
                                            <figure>
                                                <img
                                                    src={badge}
                                                    alt=""
                                                    className="mb-4"
                                                />
                                            </figure>
                                        </div>
                                        <div className="rating">
                                            {
                                                Array.from({ length : 5 }, () => '🟊').map((val,key)=>(
                                                    <FontAwesomeIcon
                                                        icon={faStar}
                                                        color={
                                                            careGiver.rating_by_customer >=
                                                            (key+1)
                                                                ? config.starActiveColor
                                                                : config.starInactiveColor
                                                        }
                                                    />
                                                    // <i className={`${( parseInt(careGiver?.rating_by_customer || 0) >= (key+1) )? 'active': 'inactive'}`}>
                                                    //     {val}
                                                    // </i>
                                                ))
                                            }

                                            <span className="rates">
                                                {careGiver.rating_by_customer}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="address_strip">
                                        <div className="address">
                                            <i
                                                className="fa fa-map-marker"
                                                aria-hidden="true"
                                            ></i>
                                            <span>
                                                {careGiver.city +
                                                    ", " +
                                                    careGiver.state_name +
                                                    " " +
                                                    careGiver.zip}
                                            </span>
                                        </div>

                                        <div className="price">
                                            <i
                                                className="fa fa-usd"
                                                aria-hidden="true"
                                            ></i>
                                            <span>
                                                ${" "}
                                                {careGiver.services?.map(
                                                    (service) => {
                                                        if (
                                                            service.service_id ==
                                                            service_id
                                                        ) {
                                                            return service.per_hour;
                                                        }
                                                    }
                                                )}{" "}
                                                Per Hour
                                            </span>
                                        </div>

                                        <div className="response_time">
                                            <i
                                                className="fa fa-clock-o"
                                                aria-hidden="true"
                                            ></i>
                                            <span>
                                                Average Response Time: 1 Hour
                                            </span>
                                        </div>
                                    </div>
                                    <div className="contentDv">
                                        <span className="experience">
                                            {careGiver.experience?.map(
                                                (exp) => {
                                                    return (
                                                        exp.year_of_experience +
                                                        " Years of Experience in " +
                                                        exp.field
                                                    );
                                                }
                                            )}
                                            {/* 3 Years of Experience in care giving{" "} */}
                                        </span>
                                        <p>{careGiver.bio}</p>
                                    </div>
                                    <div className="skills">
                                        <ul className="skills_list">
                                            {careGiver.services?.map(
                                                (service) => {
                                                    return service?.service_types?.map(
                                                        (service_type) => {
                                                            return (
                                                                <li
                                                                    key={
                                                                        service.id +
                                                                        "_" +
                                                                        service_type
                                                                    }
                                                                >
                                                                    {
                                                                        service_type
                                                                    }
                                                                </li>
                                                            );
                                                        }
                                                    );
                                                }
                                            )}
                                        </ul>
                                    </div>
                                    <div className="contentDv">
                                        {careGiver.services?.map(
                                            (service) => {
                                                if (
                                                    service.service_id ==
                                                    service_id
                                                ) {
                                                    return (
                                                        <>
                                                            {
                                                                service.service_for_age &&
                                                                <>
                                                                    <h5>Age Range</h5>
                                                                    <span>{service.service_for_age}</span>
                                                                </>
                                                            }
                                                        </>
                                                    )
                                                }
                                            }
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="reviews_box">
                                <div className="heading_wrapper">
                                    <h4>Reviews &amp; Feedback</h4>
                                    <p>
                                        Learn from the experiences of our
                                        esteemed clients We assess feedback for
                                        continuous improvisation of our service
                                        quality so that you feel assured.
                                    </p>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="content_wrapper">
                                            <h4>
                                                <span>
                                                    {careGiver.total_reviews}
                                                </span>{" "}
                                                Reviews and Feedbacks
                                            </h4>
                                            <div className="stars">
                                                <div className="stars_icons">
                                                    <FontAwesomeIcon
                                                        icon={faStar}
                                                        color={
                                                            careGiver.rating_by_customer >=
                                                            1
                                                                ? config.starActiveColor
                                                                : config.starInactiveColor
                                                        }
                                                    />
                                                    <FontAwesomeIcon
                                                        icon={faStar}
                                                        color={
                                                            careGiver.rating_by_customer >=
                                                            2
                                                                ? config.starActiveColor
                                                                : config.starInactiveColor
                                                        }
                                                    />
                                                    <FontAwesomeIcon
                                                        icon={faStar}
                                                        color={
                                                            careGiver.rating_by_customer >=
                                                            3
                                                                ? config.starActiveColor
                                                                : config.starInactiveColor
                                                        }
                                                    />
                                                    <FontAwesomeIcon
                                                        icon={faStar}
                                                        color={
                                                            careGiver.rating_by_customer >=
                                                            4
                                                                ? config.starActiveColor
                                                                : config.starInactiveColor
                                                        }
                                                    />
                                                    <FontAwesomeIcon
                                                        icon={faStar}
                                                        color={
                                                            careGiver.rating_by_customer >=
                                                            5
                                                                ? config.starActiveColor
                                                                : config.starInactiveColor
                                                        }
                                                    />
                                                </div>
                                                <span className="stars_count">
                                                    {
                                                        careGiver.rating_by_customer
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="vertical_line"></div>
                                        <div className="rating_progress">
                                            <div className="progress">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    style={{
                                                        width: `${
                                                            careGiver
                                                                .five_star_rating
                                                                .percentage || 0
                                                        }%`,
                                                    }}
                                                    aria-valuenow={
                                                        careGiver
                                                            .five_star_rating
                                                            .percentage || 0
                                                    }
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                ></div>
                                                <span className="value">
                                                    {careGiver.five_star_rating
                                                        .count || 0}
                                                </span>
                                            </div>
                                            <div className="progress">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    style={{
                                                        width: `${
                                                            careGiver
                                                                .four_star_rating
                                                                .percentage || 0
                                                        }%`,
                                                    }}
                                                    aria-valuenow={
                                                        careGiver
                                                            .four_star_rating
                                                            .percentage || 0
                                                    }
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                ></div>
                                                <span className="value">
                                                    {careGiver.four_star_rating
                                                        .count || 0}
                                                </span>
                                            </div>
                                            <div className="progress">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    style={{
                                                        width: `${
                                                            careGiver
                                                                .three_star_rating
                                                                .percentage || 0
                                                        }%`,
                                                    }}
                                                    aria-valuenow={
                                                        careGiver
                                                            .three_star_rating
                                                            .percentage || 0
                                                    }
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                ></div>
                                                <span className="value">
                                                    {careGiver.three_star_rating
                                                        .count || 0}
                                                </span>
                                            </div>
                                            <div className="progress">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    style={{
                                                        width: `${
                                                            careGiver
                                                                .two_star_rating
                                                                .percentage || 0
                                                        }%`,
                                                    }}
                                                    aria-valuenow={
                                                        careGiver
                                                            .two_star_rating
                                                            .percentage || 0
                                                    }
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                ></div>
                                                <span className="value">
                                                    {careGiver.two_star_rating
                                                        .count || 0}
                                                </span>
                                            </div>
                                            <div className="progress">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    style={{
                                                        width: `${
                                                            careGiver
                                                                .one_star_rating
                                                                .percentage || 0
                                                        }%`,
                                                    }}
                                                    aria-valuenow={
                                                        careGiver
                                                            .one_star_rating
                                                            .percentage || 0
                                                    }
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                ></div>
                                                <span className="value">
                                                    {careGiver.one_star_rating
                                                        .count || 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="client_reviews">
                                {careGiver.care_giver_reviews?.map((review) => {
                                    return (
                                        <div
                                            className="comments_box"
                                            key={review.id.toString()}
                                        >
                                            <div className="img_box">
                                                <figure>
                                                    <img
                                                        src={config.returnImage(
                                                            review.user
                                                        )}
                                                        alt=""
                                                    />
                                                </figure>
                                            </div>
                                            <div className="reivew">
                                                <div className="top_bar">
                                                    <div className="name_date">
                                                        <h4 className="name">
                                                            {
                                                                review.user
                                                                    .full_name
                                                            }
                                                        </h4>
                                                        <span className="posted_date">
                                                            {moment(
                                                                review.created_at
                                                            ).fromNow()}
                                                        </span>
                                                    </div>
                                                    <div className="ratings">
                                                        <FontAwesomeIcon
                                                            icon={faStar}
                                                            color={
                                                                review.rating >=
                                                                1
                                                                    ? config.starActiveColor
                                                                    : config.starInactiveColor
                                                            }
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={faStar}
                                                            color={
                                                                review.rating >=
                                                                2
                                                                    ? config.starActiveColor
                                                                    : config.starInactiveColor
                                                            }
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={faStar}
                                                            color={
                                                                review.rating >=
                                                                3
                                                                    ? config.starActiveColor
                                                                    : config.starInactiveColor
                                                            }
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={faStar}
                                                            color={
                                                                review.rating >=
                                                                4
                                                                    ? config.starActiveColor
                                                                    : config.starInactiveColor
                                                            }
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={faStar}
                                                            color={
                                                                review.rating >=
                                                                5
                                                                    ? config.starActiveColor
                                                                    : config.starInactiveColor
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <p>{review.comment}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                                {/* <div className="show_more_btn">
                                    <button>Show More</button>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="hiringDv mb-5">
                                <div className="button-group">
                                    <Link
                                        style={{ color: "white" }}
                                        to={`/hiring/${service_id || 0}/${id}`}
                                        className="btn hire-btn"
                                    >
                                        <FontAwesomeIcon icon={faSuitcase} />
                                        &nbsp;&nbsp; Hire Now
                                    </Link>
                                    <a className="btn disabled ml-2" disabled>
                                        <FontAwesomeIcon icon={faComment} />
                                        &nbsp;&nbsp; Chat
                                    </a>
                                </div>
                                <p className="note">
                                    You can Chat once you hire this Caregiver
                                </p>
                            </div>
                            {careGiver.lat && careGiver.lng ? (
                                <div className="care_giver_radius mb-5">
                                    <div className="heading_wrapper">
                                        <h4 className="title">
                                            {careGiver.full_name}'s Radius
                                        </h4>
                                        <p>
                                            Care giver Provide service in this
                                            area
                                        </p>
                                    </div>
                                    <div className="radius_map">
                                        <div
                                            style={{
                                                width: "100%",
                                                height: 200,
                                            }}
                                        >
                                            <GoogleMapsReact
                                                bootstrapURLKeys={{
                                                    key: config.mapsApiKey,
                                                }}
                                                center={{
                                                    lat: parseFloat(
                                                        careGiver.lat
                                                    ),
                                                    lng: parseFloat(
                                                        careGiver.lng
                                                    ),
                                                }}
                                                zoom={16}
                                                yesIWantToUseGoogleMapApiInternals
                                                onGoogleApiLoaded={({
                                                    map,
                                                    maps,
                                                }) => {
                                                    new maps.Marker({
                                                        map,
                                                        position: {
                                                            lat: parseFloat(
                                                                careGiver.lat
                                                            ),
                                                            lng: parseFloat(
                                                                careGiver.lng
                                                            ),
                                                        },
                                                        animation:
                                                            maps.Animation.DROP,
                                                    });
                                                    new maps.Circle({
                                                        strokeWeight: 1,
                                                        strokeColor:
                                                            config.primaryColor,
                                                        strokeOpacity: 0.8,
                                                        fillColor:
                                                            config.primaryColor,
                                                        fillOpacity: 0.3,
                                                        map,
                                                        center: {
                                                            lat: parseFloat(
                                                                careGiver.lat
                                                            ),
                                                            lng: parseFloat(
                                                                careGiver.lng
                                                            ),
                                                        },
                                                        radius: parseFloat(
                                                            careGiver.max_distance
                                                        ),
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            <div className="services_box mb-5">
                                <div className="heading_wrapper">
                                    <h4>Your Services</h4>
                                    <p>Let Client's Know Services you Offer</p>
                                </div>
                                {careGiver.services?.map((service) => {
                                    return (
                                        <div
                                            className="service_detail"
                                            key={service.id.toString()}
                                        >
                                            <figure>
                                                <img
                                                    src={
                                                        config.assetUrl +
                                                        "uploads/" +
                                                        service.service.image
                                                    }
                                                    alt=""
                                                />
                                            </figure>
                                            <div className="detailed ml-3">
                                                <div className="name_price">
                                                    <h5 className="service_name">
                                                        {service.service.title}
                                                    </h5>
                                                    <h5 className="service_price">
                                                        ${service.per_hour}
                                                        <span className="hours">
                                                            /Hour
                                                        </span>
                                                    </h5>
                                                </div>
                                                <p>
                                                    {
                                                        service.service
                                                            .description
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="availabilty_calender">
                                <div className="heading_wrapper">
                                    <h4>
                                        {careGiver.full_name}'s availability
                                    </h4>
                                    {/* <p>
                                        Last updated on{" "}
                                        <span className="colored">
                                            August 7 2021
                                        </span>
                                    </p> */}
                                </div>
                                <div className="calendar-container">
                                    <Calendar
                                        components={{
                                            toolbar: () => null,
                                            eventContainerWrapper: ({
                                                children,
                                            }) => {
                                                return (
                                                    <div
                                                        style={{
                                                            height: "100%",
                                                            width: "100%",
                                                            backgroundColor:
                                                                "#000",
                                                        }}
                                                    >
                                                        {children}
                                                    </div>
                                                );
                                            },
                                            eventWrapper: ({ event }) => {
                                                return (
                                                    <div
                                                        style={{
                                                            background:
                                                                event.color ==
                                                                "orange"
                                                                    ? config.primaryColor
                                                                    : "black",
                                                            color: "#FFF",
                                                            width: "100%",
                                                            height: 4,
                                                            borderRadius: 3,
                                                        }}
                                                    >
                                                        {/* {children} */}
                                                    </div>
                                                );
                                            },
                                        }}
                                        views={["month"]}
                                        style={{ height: 400 }}
                                        localizer={localization}
                                        events={careGiver.calendar}

                                        // tileDisabled={(a) => true}
                                        // value={[
                                        //     new Date("2022-03-10"),
                                        //     new Date("2022-03-06"),
                                        // ]}
                                        // selectRange={false}
                                    />
                                </div>
                                {/* <div className="jumbotron">
                                    <h1 className="text-center">
                                        <a id="left" href="#">
                                            <i className="fa fa-chevron-left"></i>
                                        </a>
                                        <span>&nbsp;</span>
                                        <span id="month"> </span>
                                        <span>&nbsp;</span>
                                        <span id="year"></span>
                                        <span>&nbsp;</span>
                                        <a id="right" href="#">
                                            <i className="fa fa-chevron-right">
                                                {" "}
                                            </i>
                                        </a>
                                    </h1>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10 col-sm-offset-1">
                                        <table
                                            className="table"
                                            id="table-calender"
                                        ></table>
                                    </div>
                                </div> */}
                                <div className="availabiltyDv">
                                    <div className="available check_availabilty">
                                        <span
                                            className="color"
                                            style={{
                                                backgroundColor: "#ff5735",
                                            }}
                                        ></span>
                                        <p>Available</p>
                                    </div>
                                    <div className="not_available check_availabilty">
                                        <span
                                            className="color"
                                            style={{ backgroundColor: "#000" }}
                                        ></span>
                                        <p>Not Available</p>
                                    </div>
                                </div>
                                {/*<div className="cancelDv">*/}
                                {/*    <p>*/}
                                {/*        Cancellation Policy is{" "}*/}
                                {/*        <span className="colored">3 Days</span>*/}
                                {/*    </p>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Single Profile Sec End Here --> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(SingleProfile);
